/* app/icons.jsx - MlIcon: extends the Huddle DS Icon with the extra Lucide
   line-icon paths Marketlens nav + features need (file, tag, gauge, target,
   layers, box, flag, briefcase, sparkles, message, etc). Same 24×24 / stroke-2
   / round-cap geometry so it is visually identical to the DS set.
   PROPOSED ADDITION: these glyphs should be folded into Icon.jsx's path map. */
(function () {
  const EXTRA = {
    "file-text": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2v6h6 M16 13H8 M16 17H8 M10 9H8",
    "file": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2v6h6",
    "folder": "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2z",
    "tag": "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2 2 0 0 0 2.828 0l6.58-6.58a2 2 0 0 0 0-2.828z M7.5 7.5h.01",
    "gauge": "M12 14l4-4 M3.34 19a10 10 0 1 1 17.32 0",
    "shield-check": "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z M9 12l2 2 4-4",
    "target": "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12z M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    "layers": "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z M2 12l8.6 3.91a2 2 0 0 0 1.65 0L22 12 M2 17l8.6 3.91a2 2 0 0 0 1.65 0L22 17",
    "box": "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z M3.3 7l8.7 5 8.7-5 M12 22V12",
    "flag": "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z M4 22v-7",
    "briefcase": "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16 M20 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z",
    "sparkles": "M9.94 14.06A2 2 0 0 0 8.5 12.6l-5.13-1.32a.5.5 0 0 1 0-.96L8.5 9a2 2 0 0 0 1.44-1.44l1.32-5.13a.5.5 0 0 1 .96 0l1.32 5.13A2 2 0 0 0 15 9l5.13 1.32a.5.5 0 0 1 0 .96L15 12.6a2 2 0 0 0-1.44 1.44l-1.32 5.13a.5.5 0 0 1-.96 0z M19 3v4 M21 5h-4 M5 17v2 M6 18H4",
    "message-circle": "M7.9 20A9 9 0 1 0 4 16.1L2 22z",
    "message-square": "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
    "check-square": "M9 11l3 3L22 4 M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11",
    "upload-cloud": "M12 13v8 M16 16l-4-4-4 4 M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3",
    "calendar-days": "M8 2v4 M16 2v4 M3 10h18 M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z M8 14h.01 M12 14h.01 M16 14h.01 M8 18h.01 M12 18h.01",
    "palette": "M12 22a10 10 0 1 1 0-20 8 8 0 0 1 0 16h-1.5a2 2 0 0 0 0 4z M6.5 12.5h.01 M9.5 8.5h.01 M14.5 8.5h.01 M17.5 12.5h.01",
    "type": "M4 7V5h16v2 M9 19h6 M12 5v14",
    "ruler": "M21.3 8.7 8.7 21.3a1 1 0 0 1-1.4 0l-4.6-4.6a1 1 0 0 1 0-1.4L15.3 2.7a1 1 0 0 1 1.4 0l4.6 4.6a1 1 0 0 1 0 1.4z M7.5 10.5l2 2 M10.5 7.5l2 2 M13.5 4.5l2 2",
    "shapes": "M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1z M14 17a3 3 0 1 0 6 0 3 3 0 0 0-6 0z M5 13h6v6H5z",
    "compass": "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M16.24 7.76l-2.12 6.36-6.36 2.12 2.12-6.36z",
    "arrow-right": "M5 12h14 M13 5l7 7-7 7",
    "send": "M14.54 21.69a.5.5 0 0 0 .93-.02l6.5-19a.5.5 0 0 0-.64-.64l-19 6.5a.5.5 0 0 0-.02.94l7.93 3.18a2 2 0 0 1 1.11 1.11z M21.85 2.15 10.91 13.09",
    "archive": "M21 8v13H3V8 M1 3h22v5H1z M10 12h4",
    "rotate-ccw": "M3 2v6h6 M3.51 15a9 9 0 1 0 2.13-9.36L3 8",
    "share": "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8 M16 6l-4-4-4 4 M12 2v13",
    "home": "M3 9.5 12 3l9 6.5V20a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z M9 22V12h6v10",
    "shuffle": "M16 3h5v5 M4 20 21 3 M21 16v5h-5 M15 15l6 6 M4 4l5 5",
    "moon": "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z",
    "sun": "M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10z M12 1v2 M12 21v2 M4.22 4.22l1.42 1.42 M18.36 18.36l1.42 1.42 M1 12h2 M21 12h2 M4.22 19.78l1.42-1.42 M18.36 5.64l1.42-1.42",
    "chevron-down": "m6 9 6 6 6-6",
    "play": "M6 3l14 9-14 9z",
    "cursor": "m3 3 7.07 16.97 2.51-7.39 7.39-2.51z",
    "eye": "M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
    "x-circle": "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M15 9l-6 6 M9 9l6 6",
    "credit-card": "M3 5h18a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z M2 10h20",
    "circle": "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z",
  };

  function MlIcon({ name, size = 18, strokeWidth = 2, className, style, ...rest }) {
    const d = EXTRA[name];
    if (!d) {
      // fall back to the DS icon for anything in the base set
      const DS = window.HuddleDesignSystem_775113;
      if (DS && DS.Icon) return React.createElement(DS.Icon, { name, size, strokeWidth, className, style, ...rest });
      return null;
    }
    const segs = d.split(" M").map((s, i) => (i === 0 ? s : "M" + s));
    return React.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24",
        fill: "none", stroke: "currentColor", strokeWidth, strokeLinecap: "round", strokeLinejoin: "round",
        className, style, "aria-hidden": "true", focusable: "false", ...rest,
      },
      segs.map((seg, i) => React.createElement("path", { key: i, d: seg }))
    );
  }

  window.MlIcon = MlIcon;
})();
